<atlas-sidebar>
  <div nav-header class="business-navbar__sidebar__header">
    <ng-container *ngIf="(businessAppBranding$ | async) === false">
      <div *ngIf="coBrandingUrl$ | async" class="business-navbar__sidebar_powered-by">
        <span class="business-navbar__sidebar_powered-by__text">
          {{ 'COMMON.POWERED_BY' | translate }}
        </span>
        <img class="business-navbar__sidebar_powered-by__logo" [src]="coBrandingUrl$ | async" />
      </div>
      <div class="business-navbar__sidebar__header__logo" [ngStyle]="{ 'max-height.px': logoHeight$ | async }">
        <img
          #logo
          *ngIf="logoUrl$ | async"
          [src]="logoUrl$ | async"
          (load)="logoLoaded(logo)"
          class="business-navbar__sidebar__header__logo__img"
        />
      </div>
    </ng-container>
    <div
      class="business-navbar__sidebar__header__center"
      [ngClass]="{
        'business-navbar__sidebar__header__center__no-logo': businessAppBranding$ | async
      }"
    >
      <div class="business-navbar__sidebar__header__center__center-name">
        {{ businessCenterName$ | async }}
      </div>
    </div>
  </div>
  <div nav-items class="business-navbar__sidebar__items">
    <atlas-bc-nav-item
      class="business-navbar__primary-item"
      *ngFor="let item of navigationItems$ | async"
      [item]="item"
    ></atlas-bc-nav-item>
  </div>
  <div nav-footer class="business-navbar__sidebar__footer_main">
    <div data-action="clicked-contact-us" class="business-navbar__sidebar__footer" (click)="openAssistanceModal()">
      <div class="business-navbar__sidebar__footer__picture">
        <glxy-avatar [src]="salespersonPictureUrl$ | async" [width]="40"></glxy-avatar>
      </div>
      <div class="business-navbar__sidebar__footer__contact">
        <div class="business-navbar__sidebar__footer__contact__name">
          {{ partnerName$ | async }}
        </div>
        <div class="business-navbar__sidebar__footer__contact__message">
          <span>
            <i class="material-icons business-navbar__sidebar__footer__contact__message__icon">chat_bubble</i>
          </span>
          <span class="business-navbar__sidebar__footer__contact__message__text">
            {{ contactMessage$ | async }}
          </span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="businessAppBranding$ | async">
      <div class="business-navbar__sidebar__footer__logo__border"></div>
      <ng-container *ngIf="logoUrl$ | async">
        <ng-container *ngIf="(coBrandingUrl$ | async) === null">
          <div class="business-navbar__sidebar__footer__logo__wide">
            <span class="business-navbar__sidebar__footer__powered-by">
              {{ 'COMMON.POWERED_BY' | translate }}
            </span>
            <img
              #logo
              [src]="logoUrl$ | async"
              (load)="logoLoaded(logo)"
              class="business-navbar__sidebar__footer__logo__img__wide"
            />
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="coBrandingUrl$ | async as coBrandingUrl">
        <div class="business-navbar__sidebar__footer__logo__narrow">
          <img
            #logo
            [src]="logoUrl$ | async"
            (load)="logoLoaded(logo)"
            class="business-navbar__sidebar__footer__logo__img__narrow"
          />
          <div class="business-navbar__sidebar__footer__powered-by__container">
            <span class="business-navbar__sidebar_powered-by__text">
              {{ 'COMMON.POWERED_BY' | translate }}
            </span>
            <img class="business-navbar__sidebar_powered-by__logo" [src]="coBrandingUrl" />
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</atlas-sidebar>
